import { Skeleton, Avatar } from '@mantine/core';
import { useApiQuery } from '@vrplatform/data';
import { Icon } from '@vrplatform/icons';

export const AppIconById = ({
  appId,
  size = 24,
}: {
  appId: string;
  size?: number;
}) => {
  const queryData = useApiQuery(
    async ($api, signal, args) => {
      const result = await $api.GET('/apps/{id}', {
        params: {
          path: {
            id: args.appId,
          },
        },
        signal,
      });

      if (result.error) throw result.error;

      const data = result.data;

      return {
        app: data,
      };
    },
    {
      skip: !appId,
      queryGroup: 'apps',
      uniqueQueryKey: `app-${appId}`,
      variables: {
        appId,
      },
      keepPreviousData: true,
      staleTime: Infinity,
    }
  );

  if (queryData.isLoading) return <Skeleton height={size} width={size} />;

  return queryData.data?.app.icon ? (
    <Avatar
      src={queryData.data.app.icon}
      size={size}
      styles={{
        placeholder: { visibility: 'hidden' },
      }}
      sx={(theme) => ({
        border: `1px solid ${theme.colors.gray[2]}`,
      })}
    />
  ) : (
    <Icon icon="ShareIcon" size={20} />
  );
};
